module.exports = __webpack_public_path__ + "img/9-2.f2559178.png";